// extracted by mini-css-extract-plugin
export default {"root":"UsersList_root__Z0jk7","avatar":"UsersList_avatar__msAaa"};